export default __webpack_public_path__ + "static/media/ecosystem.42b8f6dc.png";